export default "__VITE_PUBLIC_ASSET__aa1c2873__"